export const triggerPlausibleEvent = event => {
  if (window && window.plausible) {
    window.plausible(event, { transport: "beacon" });
  }
}
